// extracted by mini-css-extract-plugin
export default {"home":"Subject_SubScription_home__an+Gx","home2":"Subject_SubScription_home2__qH338","hr":"Subject_SubScription_hr__C8kgY","main":"Subject_SubScription_main__M+p3Y"};